<template>
  <!-- 从小程序 components/hilltop/article-card.vue 同步过来 -->
  <div class="article">
    <div class="header-box flex column content-between" :style="{ background: `center / cover no-repeat url(${$get(article, 'cover.url')})` }">
      <img v-if="article.type === 'SpecialColumn'" class="column" src="./images/column.png"/>
      <div class="browse self-end flex item-center">
        <img class="icon" src="./images/scan.png"/>
        <span class="count">{{ article.views_count }}</span>
      </div>

      <div class="content">
        <div class="title">{{ article.title }}</div>
        <div class="desc text-overflow">{{ article.subtitle }}</div>
      </div>
    </div>

    <div class="content-box flex content-between">
      <div class="date">{{ article.created_at | formatTime('YYYY-MM-DD') }}</div>
      <div class="option flex item-center">
        <img class="icon" src="./images/transmit.png"/>
        <span class="comment flex item-center">
          <img class="icon" src="./images/comment.png"/>
          <span class="count">{{ article.approved_comments_count }}</span>
        </span>
        <span @click="isLike = !isLike" class="like flex item-center">
          <img class="icon" :src="!isLike ? require('./images/like.png') : require('./images/like-select.png')"/>
          <span class="count">{{ article.likes_count }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import { Vue, Component, Prop } from 'vue-property-decorator';

  @Component
  export default class ArticleCard extends Vue {
    @Prop(Object) article

    isLike = false
  }
</script>

<style lang="scss" scoped>
  .article {
    width: 100%;
    overflow: hidden;
    background: #fff;
    box-shadow: 0px 0px 12px 1.5px rgba(204, 204, 204, 0.36);
  }

  .header-box {
    position: relative;
    width: 100%;
    height: 150px;
    border-radius: initial;
    color: #fff;

    .column {
      position: absolute;
      left: 20px;
      width: 39px;
      height: 25px;
    }

    .browse {
      padding: 15px;
      font-weight: bold;
      font-size: 13px;
      color: #fff;

      .icon {
        width: 15px;
        height: 12px;
      }

      .count {
        margin-left: 8px;
      }
    }

    .content {
      box-sizing: border-box;
      width: 100%;
      padding: 15px;
    }

    .title {
      margin-bottom: 14px;
      font-weight: bold;
      font-size: 16px;
    }
  }

  .content-box {
    padding: 15px 20px;

    .date {
      color: #ccc;
    }

    .option {
      color: #666;

      .icon {
        width: 16px;
        height: 16px;
      }

      .comment {
        margin-left: 42px;
      }

      .like {
        margin-left: 24px;
      }

      .count {
        margin-left: 4.5px;
      }
    }
  }
</style>
